import { render, staticRenderFns } from "./audioResource.vue?vue&type=template&id=4f026653&scoped=true&"
import script from "./audioResource.vue?vue&type=script&lang=js&"
export * from "./audioResource.vue?vue&type=script&lang=js&"
import style0 from "./audioResource.vue?vue&type=style&index=0&id=4f026653&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f026653",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/zhishengluo/opp-scratch/scratch/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4f026653')) {
      api.createRecord('4f026653', component.options)
    } else {
      api.reload('4f026653', component.options)
    }
    module.hot.accept("./audioResource.vue?vue&type=template&id=4f026653&scoped=true&", function () {
      api.rerender('4f026653', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/resource/audioResource.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/resource/audioResource.vue
// module id = j3OS
// module chunks = 0